/**
 * coucou-cart.js
 * Handles the free shipping progress bar in the cart drawer.
 * Runs after any cart mutation by listening to Horizon's cart update events.
 */

(function () {
  function updateShippingBar(subtotalCents) {
    const bar = document.querySelector('.coucou-cart__shipping-bar');
    if (!bar) return;

    const threshold = parseInt(bar.dataset.threshold, 10);
    if (!threshold) return;

    const progressEl = bar.querySelector('.coucou-cart__shipping-progress-bar');
    const textEl = bar.querySelector('.coucou-cart__shipping-text');
    if (!progressEl || !textEl) return;

    const progress = Math.min((subtotalCents / threshold) * 100, 100);
    progressEl.style.width = progress + '%';

    if (subtotalCents >= threshold) {
      textEl.innerHTML = '<span class="coucou-cart__shipping-icon">❊</span> Your order includes free shipping :)';
      bar.classList.add('coucou-cart__shipping-bar--achieved');
    } else {
      const remaining = threshold - subtotalCents;
      const formatted = formatMoney(remaining);
      textEl.textContent = 'Only ' + formatted + ' away from free shipping!';
      bar.classList.remove('coucou-cart__shipping-bar--achieved');
    }

    bar.dataset.current = subtotalCents;
  }

  function formatMoney(cents) {
    const eur = cents / 100;
    return '€' + eur.toFixed(2).replace('.', ',');
  }

  function fetchAndUpdate() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateShippingBar(cart.items_subtotal_price);
      })
      .catch(function () {});
  }

  function initFromDOM() {
    const bar = document.querySelector('.coucou-cart__shipping-bar');
    if (bar && bar.dataset.current) {
      updateShippingBar(parseInt(bar.dataset.current, 10));
    }
  }

  document.addEventListener('cart:update', fetchAndUpdate);
  document.addEventListener('cart:add', fetchAndUpdate);

  function observeCartTotal() {
    const target = document.querySelector('[data-cart-subtotal]');
    if (!target) return;
    const observer = new MutationObserver(function () {
      fetchAndUpdate();
    });
    observer.observe(target, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFromDOM();
      observeCartTotal();
    });
  } else {
    initFromDOM();
    observeCartTotal();
  }
})();
